<template>
  <div class="img-item-wrap" @click="showBigImage">
    <div class="img-item" :style="{ backgroundImage: `url(${$setPicSize(picUrl)})` }"></div>
  </div>
</template>

<script>
import { setPicSize } from '@zz-common/zz-utils'
import native from '@zz-common/native-adapter'

export default {
  name: 'ImgItem',
  props: ['picUrl'],
  data() {
    return {}
  },
  methods: {
    showBigImage() {
      native.wrap('enlargeImage')({
        imgUrls: this.picUrl,
        selectedIndex: 0
      })
    },
    $setPicSize(url) {
      // 后台没有返回地址给个默认的
      if (!url) {
        return setPicSize(
          'https://pic6.zhuanstatic.com/zhuanzh/21d599a8-f720-479b-b90e-b9560bd9810d.png',
          100,
          100
        )
      }
      // 部分后台返回的图片url非常规url，不做处理直接用
      const reg = /\.(png|jpg|jpeg|gif)/i
      return reg.test(url) ? setPicSize(url, 300, 300) : url
    }
  }
}
</script>

<style lang="less" scoped>
  @import './index.less';
</style>
